import { observer }            from 'mobx-react';
import { Button }              from 'antd';
import { EditOutlined }        from '@ant-design/icons';
import currentSession          from 'utils/currentSession';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import CardBox                 from 'components/App/CardBox';
import UserModel               from 'models/UserModel';
import { AppForm }            from 'components/App/AppForm';
import OrganizerForm          from 'forms/OrganizerForm.tsx';
import { showDashboardStore } from 'stores/index';

const openOrganizerForm = () => {
  AppForm.open(
    OrganizerForm,
    {
      show: showDashboardStore.showModel,
      user: showDashboardStore.organizerModel,
      userShow: showDashboardStore.userShow,
      onSuccess: () => {
        showDashboardStore.loadOrganizer(showDashboardStore.showModel.id);
      },
    },
    {
      title: <FormattedMessageWrapper id="Organisateur" />,
    },
  );
};

const ShowDashboardOrganizerBox = ({
  organizerModel,
}: {
  organizerModel: UserModel;
}) => (
  <CardBox
    content={
      <p>
        <b>
          <FormattedMessageWrapper id="Coordonnées :" />
        </b>
        <br />
        {organizerModel.company ? (
          <>
            {organizerModel.firstName} {organizerModel.lastName}
            <br />
            {organizerModel.company}
            {organizerModel.email && (
              <>
                <br />
                {organizerModel.email}
              </>
            )}
            <br />
            {organizerModel.phone}
            <br />
          </>
        ) : (
          <FormattedMessageWrapper id="Non renseignées" />
        )}
      </p>
    }
    extra={
      currentSession.isAdmin && (
        <Button
          htmlType="button"
          icon={<EditOutlined />}
          onClick={openOrganizerForm}
        />
      )
    }
    loading={organizerModel.isLoading}
    title={<FormattedMessageWrapper id="Organisateur" />}
  />
);

export default observer(ShowDashboardOrganizerBox);
